toggleSlideover = () => {
    document.documentElement.classList.toggle('tw-overflow-hidden')
    document.getElementById('slideover-container').classList.toggle('tw-invisible');
    document.getElementById('slideover-bg').classList.toggle('tw-opacity-0');
    document.getElementById('slideover-bg').classList.toggle('tw-opacity-100');
    document.getElementById('slideover').classList.toggle('tw-translate-y-full');
}

let videos = document.querySelectorAll('.js-embed-video');
if(videos.length >= 1){
    for (let i = 0; i < videos.length; i++) {
        videos[i].addEventListener('click', function() {
            event.preventDefault();
            let iframe = document.createElement('iframe');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('allow', 'autoplay; fullscreen');
            iframe.setAttribute('src', 'https://www.youtube.com/embed/'+ this.dataset.videoid +'?autoplay=1');
            iframe.classList.add('tw-w-full', 'tw-h-full')
            this.innerHTML = '';
            this.appendChild(iframe);
            this.classList.add('before:tw-content-none')
        });
    };
}

document.addEventListener("DOMContentLoaded", () => {
    const copyButton = document.getElementById("copy-button")
    if(copyButton){
        copyButton.addEventListener("click", () => {
            const url = window.location.href;
            navigator.clipboard.writeText(url)
            .then(() => {
                console.log('URL copied to clipboard');
            })
            .catch(err => {
                console.log('Failed to copy text: ', err);
            });
        });
    }
    var width = (window.innerWidth > 0) ? window.innerWidth : document.documentElement.clientWidth;
        if(width > 767){
            window.addEventListener('scroll', function(e) {
                let elem = document.activeElement;
                if(elem && elem.matches('iframe')){
                const iframePodcast = document.getElementById('iframe-podcast')
                let scrolled = window.scrollY,
                height = window.innerHeight - iframePodcast.offsetHeight;
                if (scrolled > height) {
                    iframePodcast.classList.add('podcast-frame', '!tw-fixed', '!tw-bottom-0', '!tw-right-0', 'tw-w-full');
                } else {
                    iframePodcast.classList.remove('podcast-frame', '!tw-fixed', '!tw-bottom-0', '!tw-right-0', 'tw-w-full');
                };
                }
            });
        }

})



